'use client';

import { Suspense, useEffect, useRef } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

const HJID = Number.parseInt(process.env.NEXT_PUBLIC_HJID ?? '', 10);
const HJSV = Number.parseInt(process.env.NEXT_PUBLIC_HJSV ?? '', 10);
const hotjarConfigured = Number.isFinite(HJID) && Number.isFinite(HJSV);

function HotjarAnalyticsInner() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams.toString();
  const initialized = useRef(false);

  useEffect(() => {
    if (!hotjarConfigured) return;

    let cancelled = false;
    const path = search ? `${pathname}?${search}` : pathname;

    void import('@hotjar/browser').then(({ default: Hotjar }) => {
      if (cancelled) return;
      if (!initialized.current) {
        Hotjar.init(HJID, HJSV, {
          debug: process.env.NODE_ENV === 'development',
        });
        initialized.current = true;
        return;
      }
      Hotjar.stateChange(path);
    });

    return () => {
      cancelled = true;
    };
  }, [pathname, search]);

  return null;
}

/** Hotjar session recordings and heatmaps (consent-gated via parent). */
export function HotjarAnalytics() {
  if (!hotjarConfigured) return null;
  return (
    <Suspense fallback={null}>
      <HotjarAnalyticsInner />
    </Suspense>
  );
}
